import me from "models/me";
import { getStore } from "store";
import * as _ from "lodash";

export default function (pref: string, value: boolean = true) {
    return (nextState, replace, callback) => {
        const { scope } = getStore().getState();
        if (!me.canViewBrand()) {
            replace({ pathname: "/profile" });
        } else if (scope.brand) {
            const preferenceValue = scope.brand.getPreference(pref);
            if (preferenceValue !== value && !(_.isUndefined(preferenceValue) && value === false)) {
                replace({ pathname: "/404" });
            }
        } else {
            replace({ pathname: "/404" });
        }
        callback();
    };
}
